import videojs from 'video.js';
import MenuCaptions from '../MenuCaptions';
import MenuQualitySelector from '../MenuQualitySelector';
import MenuSpeedSelector from '../MenuSpeedSelector';
import SettingsMenuHeader from '../SettingsMenuHeader';
const MenuButton = videojs.getComponent('MenuButton');
const MenuItem = videojs.getComponent('MenuItem');
const Menu = videojs.getComponent('Menu');
// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 */
const onPlayerReady = (player) => {
    player.addClass('vjs-settings-button');
    // @ts-expect-error - legit error, predates strict TS
    player.controlBar.settings = player.controlBar.addChild('settingsButton', {}, 10);
};
/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function settingsButton
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
// eslint-disable-next-line space-before-function-paren
const settingsButton = function () {
    // document.sbInit++;
    this.ready(() => {
        onPlayerReady(this);
    });
};
/**
 * Button to seek forward/back
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class SeekToggle
 */
class SettingsButton extends MenuButton {
    constructor(player, options) {
        super(player, options);
        this.mouseIsInside = false;
        const settingButtonId = 'settings-menu-button';
        this.el().setAttribute('aria-label', 'Settings Menu');
        this.menuButton_.setAttribute('id', settingButtonId);
        this.menu.hide();
        this.isOpen = false;
        this.menu.on('mouseover', () => {
            this.mouseIsInside = true;
        });
        this.menu.on('mouseleave', () => {
            this.mouseIsInside = false;
        });
        this.on(this.player().contentEl(), 'mouseup', (e) => {
            var _a, _b;
            const { target } = e;
            const parent = (_a = target) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (!this.mouseIsInside) {
                super.unpressButton();
                //if clicking on anything but the settings button, set is open to false, since the onclick below will set it for us when the button is clicked
                if (!(((_b = target) === null || _b === void 0 ? void 0 : _b.id) === settingButtonId || (parent === null || parent === void 0 ? void 0 : parent.id) === settingButtonId)) {
                    this.isOpen = false;
                }
            }
        });
    }
    handleClick(e) {
        this.isOpen = !this.isOpen;
        //only handle clicks if the new state will be open. this prevents reopening after super.unpressing above.
        if (this.isOpen) {
            super.handleClick(e);
        }
    }
    closeSettings() {
        super.unpressButton();
        this.isOpen = false;
    }
    buildCSSClass() {
        return `vjs-settings-button ${super.buildCSSClass()}`;
    }
    // /**
    //  * Create the settings menu
    //  *
    //  * @return {Menu} Menu object populated with items
    //  * @method createMenu
    //  */
    createMenu() {
        const player = this.player();
        const menu = new Menu(player);
        const settingsMenuHeader = new SettingsMenuHeader(player, {}, () => this.closeSettings());
        menu.addChild(settingsMenuHeader);
        const closedCaptionsItem = new MenuItem(player, { label: 'closed captions' });
        closedCaptionsItem.addChild(new MenuCaptions(player, {}));
        menu.addItem(closedCaptionsItem);
        const playerSpeedItem = new MenuItem(player, { label: 'speed' });
        playerSpeedItem.addChild(new MenuSpeedSelector(player, {}));
        menu.addItem(playerSpeedItem);
        const playerQualityItem = new MenuItem(player, { label: 'quality' });
        playerQualityItem.addChild(new MenuQualitySelector(player, {}));
        menu.addItem(playerQualityItem);
        return menu;
    }
}
videojs.registerComponent('SettingsButton', SettingsButton);
// Register the plugin with video.js.
registerPlugin('settingsButton', settingsButton);
export default settingsButton;
//# sourceMappingURL=SettingsButton.js.map